<template>
	<div class="contentTab">
		<template v-if="!show && !infoLoads">
			<main-table
					v-if="getStatementsList"
					:flag="flag"
					:pageTitle='title'
					:headers="headers"
					:listItems="getStatementsList"
					:filtersList="statementsFilter"
					@updateClickButton="onClickButton"
					@updateCreate="onCreate"
					@updateSearch="onFilter"
					@updateRefreshFilters="onFilter"
					@updateChangeSort="onFilter"
					:uniqId="uniqId"
					:is-export="isExport()"
					is-export-permissions
					@updateExport="onExport"
					:department_id="user?.department_id"
					@updateSettings="onSettingsOpen"
					:isCreate="false"
			></main-table>
		</template>
		<template v-if="show">
			<StatementCreateForm
					v-on:backFromCreate="backFromCreate"
					v-on:backToMainTB="backToMainTB"
			></StatementCreateForm>
		</template>
		<view-all-loads
				v-if="infoLoads"
				:permissions="permissions"
				:allLoadsInfo="getInfoList"
				:filterLoads="getFilterLoads"
				:id="item.id"
				loadsFlag="all"
				v-on:backFromLoads="backFromLoads"
		></view-all-loads>
		<v-snackbar shaped top v-model="snackbar" elevation="24" vertical>
			Do you confirm the deletion?
			<v-card-actions>
				<v-flex d-flex justify-end>
					<v-btn small color="green" class="mt-0 ml-auto" text @click="deleteAction">Yes</v-btn>
					<v-btn small color="red" class="mt-0" text @click="snackbar = false">Close</v-btn>
				</v-flex>
			</v-card-actions>
		</v-snackbar>
		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="settings"
		></table-settings>
	</div>
</template>

<script>
import ViewAllLoads from "@/components/Accounting/dispatchers-st-ts/view-all-loads/view-all-loads.component.vue";
import StatementCreateForm from "@/components/Accounting/dispatchers-st-ts/statements-create-form/statements-create-form.component.vue";

import { mapActions, mapGetters } from "vuex";
// components
const TableSettings = () => import("@/shared/TableSettings/TableSettings");
// constants
import getUniqId from "@/helper/getUniqId";
import { PERMISSIONS, TAB } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";

export default {
	name: "StatementsDispatch",
	components: {
		StatementCreateForm,
		ViewAllLoads,
		TableSettings
	},
	props: {
		id: [ String, Number ],
		isGeneralTitle: {
			type: Boolean,
			default: true,
		},
		textGeneralTitle: {
			type: String,
			default: "Statements Items",
		},
		user: Object,
	},
	computed: {
		...mapGetters([
			'statementsFilter',
			'getStatementsList',
			'getInfoList',
			'getFilterLoads',
			'permissions',
			'statementsSettingsDefault',
			'statementsSettings',
			'statementsHeaders',
			'permissionsDefault',
		]),
		settings() {
			return this.statementsSettings;
		},
		headers() {
			return this.statementsHeaders;
		}
	},
	data: () => ({
		itemRemove: null,
		snackbar: false,
		title: "Dispatchers statements",
		flag: TAB.USER_TAB_ST_ST__DISPATCHERS,
		item: null,
		show: false,
		listItems: [],
		infoLoads: false,
		isTableSettingsDrawer: false,
		uniqId: null,
		// id: null
	}),
	methods: {
		...mapActions([
			'updateStatementFilterUser',
			'getListOfStatementsUser',
			'getListInfo',
			'deleteStatement',
			'onExportLink',
			'onStatementsSettingsReset',
			'onStatementsSettingsSave',
			'onStatementsSettingsAll',
		]),
		isExport() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_ST_TS, PERMISSIONS.EXPORT ];
			return getPermissionsMod({ list, path });
		},
		async onSettingsCancel() {
			this.onSettingsClose();
			await this.onStatementsSettingsReset();
		},
		onSettingsClose() {
			this.isTableSettingsDrawer = false;
		},
		async onSettingsSave() {
			await this.onStatementsSettingsSave();
			this.uniqId = getUniqId();
		},
		async onSettingsAll(value) {
			await this.onStatementsSettingsAll(value);
		},
		onSettingsOpen() {
			this.isTableSettingsDrawer = true;
		},
		async onExport(values) {
			values.id = this.id;
			values.setting = [
				"id",
				"created_by",
				"date",
				"gross",
				"count_load",
				"rpm",
				"amount",
				"dispatcher_rate",
			];

			await this.onExportLink({ values, requestKey: 'dispatcher/statement', isSetting: 1 });
		},
		onClickButton({ key, item }) {
			if (key === "openLoads") {
				this.item = item;
				this.openLoad(item);
			}
			if (key === "delete") {
				this.checkRemove(item);
			}
		},
		async openLoad(item) {
			// if (this.permissions[PERMISSIONS.EDIT] || this.permissions[PERMISSIONS.VIEW] || this.permissions['19']) {
			this.infoLoads = true;
			await this.getListInfo(item.id);
			// }
		},
		checkRemove(item) {
			this.itemRemove = item;
			this.snackbar = true;
		},
		async deleteAction() {
			await this.deleteStatement(this.itemRemove);
			this.snackbar = false;
			this.itemRemove = null;
		},
		async onFilter(info) {
			// await this.updateStatementFilterUser(info.filterModList);
			const id = this.id;
			
			if (!info.filterModList) {
				info.filterModList = {}; // создаем объект, если его нет
			}

			// Проверяем, есть ли в filterModList массив filter_dispatcher_name
			if (Array.isArray(info.filterModList.filter_dispatcher_name)) {
				// Если массив существует, добавляем id в него
				info.filterModList.filter_dispatcher_name.push(id);
			} else {
				// Если массива нет, создаем его с id
				info.filterModList.filter_dispatcher_name = [ id ];
			}

			// Выполняем обновление фильтра
			await this.updateStatementFilterUser(info.filterModList);
		},
		onCreate() {
			this.show = true;
			this.infoLoads = false;
		},
		async deleteItem(item) {
			await this.deleteStatement(item);
		},
		backToMainTB() {
			this.infoLoads = false;
			this.show = false;
			this.getList();
		},
		backFromLoads() {
			this.infoLoads = false;
		},
		backFromCreate() {
			this.show = false;
			this.infoLoads = false;
		},
		async getList() {
			await this.getListOfStatementsUser();
		}
	},
	async mounted() {
		// await this.getListOfStatementsUser();
		// const id = this.$route.params.id;
		//
		// this.id = id;
		const id = this.id;

		await this.updateStatementFilterUser({ filter_dispatcher_name: [ id ] });

		// {filter_dispatcher_name: [29]}
	},
};
</script>
